// extracted by mini-css-extract-plugin
export default {"searchInputRoot":"search_box-module___searchInputRoot___f35db647"};